/* eslint-disable import/prefer-default-export */
import styled from "styled-components";

export const Container = styled.div`
  padding: 24px 32px;

  .settings-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
    gap: 24px;

    .settings-header-left {
      flex: 1;
    }

    .settings-title {
      font-size: 34px;
      color: #3d3b48;
      margin-bottom: 8px;
    }

    .settings-subtitle {
      font-size: 16px;
      color: ${({ theme }) => theme.primary70};
      margin: 0;
    }

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: stretch;

      .settings-header-left {
        margin-bottom: 16px;
      }
    }
  }

  .subscription-card {
    margin-bottom: 24px;

    .ant-card-head {
      border-bottom: 1px solid ${({ theme }) => theme.primaryLight};
      padding: 20px 24px;

      .ant-card-head-title {
        font-size: 20px;
        font-weight: 600;
        color: ${({ theme }) => theme.primaryDark};
      }
    }

    .ant-card-body {
      padding: 24px;
    }
  }

  .subscription-content {
    .subscription-status {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 24px;
      padding-bottom: 24px;
      border-bottom: 1px solid ${({ theme }) => theme.primaryLight};

      .status-tag {
        font-size: 16px;
        padding: 6px 16px;
        border-radius: 6px;
      }

      .status-description {
        font-size: 16px;
        color: ${({ theme }) => theme.primary70};
      }
    }

    .subscription-details {
      margin-bottom: 24px;

      .ant-table-thead > tr > th {
        background: ${({ theme }) => theme.primaryLight};
        font-weight: 600;
        font-size: 15px;
        color: ${({ theme }) => theme.primaryDark};
        padding: 16px;
      }

      .ant-table-tbody > tr > td {
        padding: 16px;
        font-size: 15px;
        color: ${({ theme }) => theme.primaryDark};
      }

      .ant-table-tbody > tr:hover > td {
        background: ${({ theme }) => theme.primaryLight}40;
      }

      .ant-table-cell {
        border-color: ${({ theme }) => theme.primaryLight};
      }
    }

    .subscription-actions {
      display: flex;
      gap: 12px;
      flex-wrap: wrap;
    }
  }
`;

